import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { chooseNewMantelpiece, chooseNewScrapbook, } from 'actions/myself';
import getQualities from 'selectors/qualityPicker/getQualities';
import QualityPicker from 'components/QualityPicker';
import getItem from 'selectors/myself/getItem';


import PossibleDisplayQualityComponent from './PossibleDisplayQualityComponent';
import { IQuality } from 'types/qualities';
import { IAppState } from 'types/app';

interface State {
  isChanging: boolean,
  isQualityPickerOpen: boolean,
}

export class PossibleDisplayQualityContainer extends Component<Props, State> {
  static displayName = "PossiblDisplayQualityContainer";

  state = {
    isChanging: false,
    isQualityPickerOpen: false,
  };

  handleChoose = async (item: IQuality) => {
    const { dispatch, nature } = this.props;
    const action = nature === 'Thing' ? chooseNewMantelpiece : chooseNewScrapbook;
    this.setState({ isChanging: true });
    await dispatch(action(item));
    this.setState({ isChanging: false });
  };

  handleClick = () => {
    this.handleOpenQualityPicker();
  };

  handleOpenQualityPicker = () => {
    this.setState({ isQualityPickerOpen: true });
  };

  handleRequestClose = () => {
    this.setState({ isQualityPickerOpen: false });
  };

  render = () => {
    const { item, nature, qualityPickerQualities } = this.props;
    const { isQualityPickerOpen, isChanging } = this.state;

    return (
      <Fragment>
        <PossibleDisplayQualityComponent
          isChanging={isChanging}
          item={item}
          onClick={this.handleClick}
        />
        <QualityPicker
          activateButtonLabel="Flaunt"
          header={`Choose your new ${nature === 'Thing' ? 'Mantelpiece item' : 'Scrapbook status'}`}
          isOpen={isQualityPickerOpen}
          onChoose={this.handleChoose}
          onRequestClose={this.handleRequestClose}
          qualities={qualityPickerQualities}
        />
      </Fragment>
    );
  }
}

interface OwnProps {
  dispatch: Function,
  item: IQuality | null,
  nature: string,
}

const mapStateToProps = (state: IAppState, props: OwnProps) => ({
  item: getItem(state, props),
  qualityPickerQualities: getQualities(state, props),
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export default connect(mapStateToProps)(PossibleDisplayQualityContainer);